<template>
  <div class="mod-order-list">
    <div class="page-header">
      <span class="page-header__title">订单列表</span>
    </div>

    <div class="page-body">
      <!-- 筛选栏 -->
      <div class="toolbar">
        <el-input
          v-model="dataForm.keyword"
          placeholder="请输入内容"
          clearable
          class="toolbar__search"
          @keyup.enter.native="handleSearch">
          <el-select v-model="searchField" slot="prepend" class="toolbar__prepend">
            <el-option label="订单号" value="orderCode"></el-option>
            <el-option label="用户号" value="userId"></el-option>
          </el-select>
        </el-input>
        <el-select
          v-model="dataForm.orderType"
          placeholder="全部状态"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option
            v-for="item in payStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select
          v-model="dataForm.commodityType"
          placeholder="全部商品类型"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option
            v-for="(label, value) in commodityTypeMap"
            :key="value"
            :label="label"
            :value="value">
          </el-option>
        </el-select>
        <el-input
          v-model="dataForm.agentAccount"
          placeholder="代理账号"
          clearable
          class="toolbar__select"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch">
        </el-input>
        <el-input
          v-model="dataForm.lineUrl"
          placeholder="线路地址"
          clearable
          class="toolbar__select"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch">
        </el-input>
        <el-select
          v-model="dataForm.peyType"
          placeholder="全部支付方式"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option
            v-for="(label, value) in payTypeMap"
            :key="value"
            :label="label"
            :value="value">
          </el-option>
        </el-select>
        <el-select
          v-model="dataForm.merchantType"
          placeholder="全部支付通道"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option
            v-for="item in merchantOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select
          v-model="dataForm.actualMerchantType"
          placeholder="全部实际支付通道"
          clearable
          class="toolbar__select toolbar__select--wide"
          @change="handleSearch">
          <el-option
            v-for="item in merchantOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="toolbar__date"
          @change="handleSearch">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <div class="toolbar__right">
          <el-button icon="el-icon-download" @click="handleExport">导出 Excel</el-button>
        </div>
      </div>

      <!-- 订单表格 -->
      <div class="panel">
        <div class="panel__summary">
          筛选结果总金额：<b>¥{{ formatAmount(totalRechargeAmount) }}</b>
        </div>
        <el-table :data="dataList" v-loading="loading" style="width: 100%;">
          <el-table-column prop="orderCode" label="订单号" min-width="190"></el-table-column>
          <el-table-column prop="userId" label="用户号" min-width="130"></el-table-column>
          <el-table-column label="代理账号" min-width="130">
            <template slot-scope="scope">{{ scope.row.agentAccount || '—' }}</template>
          </el-table-column>
          <el-table-column label="线路地址" min-width="220" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.lineUrl || '—' }}</template>
          </el-table-column>
          <el-table-column label="类型" width="90">
            <template slot-scope="scope">{{ commodityTypeMap[scope.row.commodityType] || '—' }}</template>
          </el-table-column>
          <el-table-column label="套餐/视频" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">{{ specLabel(scope.row.commoditySpecification) }}</template>
          </el-table-column>
          <el-table-column label="金额" min-width="110">
            <template slot-scope="scope">¥{{ formatAmount(scope.row.rechargeAmount) }}</template>
          </el-table-column>
          <el-table-column label="支付方式" width="100">
            <template slot-scope="scope">{{ payTypeName(scope.row.peyType) }}</template>
          </el-table-column>
          <el-table-column label="支付通道" min-width="130">
            <template slot-scope="scope">{{ merchantName(scope.row.merchantType) }}</template>
          </el-table-column>
          <el-table-column label="实际支付通道" min-width="130">
            <template slot-scope="scope">{{ merchantName(scope.row.actualMerchantType) }}</template>
          </el-table-column>
          <el-table-column label="状态" width="110">
            <template slot-scope="scope">
              <el-tag :type="statusTagType(scope.row.orderType)" size="small">
                {{ orderStatusName(scope.row.orderType) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="备注" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.remark || '—' }}</template>
          </el-table-column>
          <el-table-column prop="foundTime" label="订单时间" min-width="170">
            <template slot-scope="scope">{{ scope.row.foundTime || '—' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
              <template v-if="canOperate(scope.row)">
                <el-button type="text" size="small" @click="openOperation(scope.row, 'complete')">补单</el-button>
                <el-button type="text" size="small" class="danger-text" @click="openOperation(scope.row, 'cancel')">取消</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>

    <!-- 订单详情 -->
    <el-dialog :visible.sync="detailVisible" title="订单详情" width="720px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="订单号">{{ detail.orderCode || '—' }}</el-descriptions-item>
        <el-descriptions-item label="第三方订单号">{{ detail.trilateralCode || '—' }}</el-descriptions-item>
        <el-descriptions-item label="用户号">{{ detail.userId || '—' }}</el-descriptions-item>
        <el-descriptions-item label="商品类型">{{ commodityTypeMap[detail.commodityType] || '—' }}</el-descriptions-item>
        <el-descriptions-item label="商品规格" :span="2">{{ specLabel(detail.commoditySpecification) }}</el-descriptions-item>
        <el-descriptions-item label="金额">¥{{ formatAmount(detail.rechargeAmount) }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ orderStatusName(detail.orderType) }}</el-descriptions-item>
        <el-descriptions-item label="支付通道">{{ merchantName(detail.merchantType) }}</el-descriptions-item>
        <el-descriptions-item label="实际支付通道">{{ merchantName(detail.actualMerchantType) }}</el-descriptions-item>
        <el-descriptions-item label="订单时间">{{ detail.foundTime || '—' }}</el-descriptions-item>
        <el-descriptions-item label="通道切换次数">{{ detail.channelSwitchCount || 0 }}</el-descriptions-item>
        <el-descriptions-item label="IP地址">{{ detail.address || '—' }}</el-descriptions-item>
        <el-descriptions-item label="渠道">{{ detail.promotionSource || '—' }}</el-descriptions-item>
        <el-descriptions-item label="来源域名" :span="2">{{ detail.sourceUrl || '—' }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detail.remark || '—' }}</el-descriptions-item>
      </el-descriptions>
      <template slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 补单 / 取消 -->
    <el-dialog
      :visible.sync="operationVisible"
      :title="operationType === 'complete' ? '手动补单' : '取消订单'"
      width="480px"
      :close-on-click-modal="false">
      <el-form label-position="top">
        <el-form-item label="订单号">
          <el-input :value="operationForm.orderCode" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="operationType === 'complete'" label="佣金发放">
          <el-radio-group v-model="operationForm.commissionState">
            <el-radio :label="2">不发放佣金</el-radio>
            <el-radio :label="1">向上级代理发放佣金</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="operationType === 'complete' ? '备注' : '取消原因'">
          <el-input
            v-model="operationForm.remark"
            type="textarea"
            :rows="3"
            :placeholder="operationType === 'complete' ? '选填，会保存为「手动完成 {备注}」' : '选填，直接写入订单备注'">
          </el-input>
        </el-form-item>
      </el-form>
      <el-alert
        v-if="operationType === 'complete'"
        type="warning"
        :closable="false"
        show-icon
        title="补单会把订单置为支付成功并发放金币 / VIP / 影片权益。订单更新与权益发放在同一事务中，任一步失败会整体回滚">
      </el-alert>
      <el-alert
        v-else
        type="info"
        :closable="false"
        show-icon
        title="取消后订单状态将变为「订单超时」，备注会写入订单记录">
      </el-alert>
      <template slot="footer">
        <el-button
          :type="operationType === 'complete' ? 'primary' : 'danger'"
          :loading="operationSubmitting"
          @click="submitOperation">
          确定{{ operationType === 'complete' ? '补单' : '取消订单' }}
        </el-button>
        <el-button @click="operationVisible = false">返回</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPayOrderPage,
  getPaymentPlatforms,
  buildOrderExportUrl,
  manualCompleteOrder,
  cancelOrder,
  ORDER_COMMODITY_TYPE_MAP,
  ORDER_PAY_TYPE_MAP,
  COMMODITY_SPEC_MAP
} from '@/api/trade'

// 支付状态：0=待支付 1=支付成功 2=支付失败 3=订单超时 4=第三方失败
// 已支付成功的订单不能补单也不能取消，其余状态都允许
const OPERABLE_STATUSES = [0, 2, 3, 4]

export default {
  name: 'OrderList',
  data () {
    return {
      loading: false,
      dataList: [],
      page: 1,
      limit: 10,
      total: 0,
      totalRechargeAmount: 0,
      searchField: 'orderCode',
      dateRange: null,
      dataForm: {
        keyword: '',
        orderType: '',
        commodityType: '',
        agentAccount: '',
        lineUrl: '',
        peyType: '',
        merchantType: '',
        actualMerchantType: ''
      },
      // 后端下发的名称映射
      merchantNameMap: {},
      orderStatusMap: {},
      payStatusOptions: [],
      detailVisible: false,
      detail: {},
      // 补单 / 取消
      operationVisible: false,
      operationType: 'complete',
      operationSubmitting: false,
      operationForm: {
        orderCode: '',
        remark: '',
        commissionState: 2
      }
    }
  },

  computed: {
    commodityTypeMap () {
      return ORDER_COMMODITY_TYPE_MAP
    },

    payTypeMap () {
      return ORDER_PAY_TYPE_MAP
    },

    // 通道下拉复用 loadPlatforms 拉回来的商户字典，避免前端再维护一份会过期的枚举
    merchantOptions () {
      return Object.keys(this.merchantNameMap).map(value => ({
        value,
        label: this.merchantNameMap[value]
      }))
    }
  },

  created () {
    this.loadPlatforms()
    this.loadList()
  },

  methods: {
    // 购买影片的订单这里放的是影片信息而不是规格枚举，匹配不上就原样展示
    specLabel (value) {
      if (value === undefined || value === null || value === '') {
        return '—'
      }
      return COMMODITY_SPEC_MAP[Number(value)] || value
    },

    // 通道 / 状态名称由后端下发
    loadPlatforms () {
      return getPaymentPlatforms().then(({ data: res }) => {
        if (res.code !== 0) {
          return
        }
        const merchantTypes = (res.data && res.data.merchantTypes) || []
        const payStatuses = (res.data && res.data.payStatuses) || []

        const merchantMap = {}
        merchantTypes.forEach(item => {
          merchantMap[item.merchantType] = item.merchantsName
        })
        this.merchantNameMap = merchantMap

        const statusMap = {}
        payStatuses.forEach(item => {
          statusMap[item.statusCode] = item.statusName
        })
        this.orderStatusMap = statusMap
        this.payStatusOptions = payStatuses.map(item => ({
          value: String(item.statusCode),
          label: item.statusName
        }))
      }).catch(() => {})
    },

    buildParams () {
      const params = {
        page: this.page,
        limit: this.limit
      }
      // 搜索字段由前置下拉决定，避免同时传两个条件导致互相排斥
      if (this.dataForm.keyword) {
        params[this.searchField] = this.dataForm.keyword
      }
      if (this.dataForm.orderType !== '') {
        params.orderType = this.dataForm.orderType
      }
      if (this.dataForm.commodityType !== '') {
        params.commodityType = this.dataForm.commodityType
      }
      if (this.dataForm.agentAccount) {
        params.agentAccount = this.dataForm.agentAccount.trim()
      }
      if (this.dataForm.lineUrl) {
        params.lineUrl = this.dataForm.lineUrl.trim()
      }
      if (this.dataForm.peyType !== '') {
        params.peyType = this.dataForm.peyType
      }
      if (this.dataForm.merchantType !== '') {
        params.merchantType = this.dataForm.merchantType
      }
      if (this.dataForm.actualMerchantType !== '') {
        params.actualMerchantType = this.dataForm.actualMerchantType
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0]
        params.endDate = this.dateRange[1]
      }
      return params
    },

    loadList () {
      this.loading = true
      return getPayOrderPage(this.buildParams()).then(({ data: res }) => {
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          this.totalRechargeAmount = 0
          return this.$message.error(res.msg)
        }
        // 该接口的数据结构为 data.pageData.list / data.pageData.total
        const pageData = (res.data && res.data.pageData) || {}
        this.dataList = pageData.list || []
        this.total = pageData.total || 0
        this.totalRechargeAmount = res.data.totalRechargeAmount || 0
      }).catch(() => {
        this.$message.error('加载订单列表失败')
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch () {
      this.page = 1
      this.loadList()
    },

    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.loadList()
    },

    handlePageChange (val) {
      this.page = val
      this.loadList()
    },

    handleExport () {
      const params = this.buildParams()
      delete params.page
      delete params.limit
      window.location.href = buildOrderExportUrl(params)
    },

    openDetail (row) {
      this.detail = { ...row }
      this.detailVisible = true
    },

    openOperation (row, type) {
      this.operationType = type
      this.operationForm = {
        orderCode: row.orderCode,
        remark: '',
        commissionState: 2
      }
      this.operationVisible = true
    },

    submitOperation () {
      const isComplete = this.operationType === 'complete'
      const payload = isComplete
        ? {
          orderCode: this.operationForm.orderCode,
          remark: this.operationForm.remark,
          commission_state: this.operationForm.commissionState
        }
        : {
          orderCode: this.operationForm.orderCode,
          remark: this.operationForm.remark
        }

      this.operationSubmitting = true
      const request = isComplete ? manualCompleteOrder(payload) : cancelOrder(payload)
      request.then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success(res.data || (isComplete ? '补单成功' : '取消成功'))
        this.operationVisible = false
        this.loadList()
      }).catch(() => {
        this.$message.error(isComplete ? '补单失败' : '取消失败')
      }).finally(() => {
        this.operationSubmitting = false
      })
    },

    // 已支付成功的订单不允许补单 / 取消
    canOperate (row) {
      return OPERABLE_STATUSES.includes(Number(row.orderType))
    },

    merchantName (merchantType) {
      if (!merchantType) {
        return '—'
      }
      return this.merchantNameMap[merchantType] || merchantType
    },

    // peyType 后端返回的是字符串，用 Number 归一后再查表
    payTypeName (peyType) {
      if (peyType === undefined || peyType === null || peyType === '') {
        return '—'
      }
      return ORDER_PAY_TYPE_MAP[Number(peyType)] || `未知(${peyType})`
    },

    orderStatusName (orderType) {
      if (orderType === undefined || orderType === null || orderType === '') {
        return '—'
      }
      return this.orderStatusMap[Number(orderType)] || `未知(${orderType})`
    },

    statusTagType (orderType) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger',
        3: 'info',
        4: 'danger'
      }
      return typeMap[Number(orderType)] || 'info'
    },

    formatAmount (value) {
      const num = Number(value || 0)
      if (Number.isNaN(num)) {
        return '0.00'
      }
      const [integer, decimal] = num.toFixed(2).split('.')
      return `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${decimal}`
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-order-list {
  background-color: #f5f7fa;
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}

.page-body {
  padding: 16px;
}

.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &__search {
    width: 320px;
    margin-right: 12px;
  }

  &__prepend {
    width: 100px;
  }

  &__select {
    width: 150px;
    margin-right: 12px;

    // 「全部实际支付通道」比其它 placeholder 多两个字，150px 会被截断
    &--wide {
      width: 180px;
    }
  }

  &__date {
    margin-right: 12px;
  }

  &__right {
    margin-left: auto;
  }
}

.panel {
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 0 16px 16px;

  &__summary {
    padding: 16px 0;
    font-size: 13px;
    color: #606266;

    b {
      color: #f56c6c;
      font-size: 14px;
    }
  }
}

.danger-text {
  color: #f56c6c;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

::v-deep .el-table th {
  background-color: #fafbfc;
  color: #909399;
  font-weight: 500;
}

::v-deep .toolbar__prepend .el-input__inner {
  background-color: #f5f7fa;
}
</style>
